import { useMemo, useState } from "react";
import { Search, Check } from "lucide-react";
import { fmtH } from "../lib/planning";

/** Elenco dipendenti con ricerca e selezione multipla (checkbox). `selected` = array di id. */
export function EmployeeMultiSelect({ employees, selected, onChange, testPrefix = "emp-multi", maxHeight = "max-h-56" }) {
    const [q, setQ] = useState("");
    const list = useMemo(() => {
        const needle = q.trim().toLowerCase();
        return (employees || []).filter((e) => !needle || `${e.cognome} ${e.nome} ${e.matricola || ""}`.toLowerCase().includes(needle));
    }, [employees, q]);
    const toggle = (id) => onChange(selected.includes(id) ? selected.filter((x) => x !== id) : [...selected, id]);
    return (
        <div className="rounded-md border border-slate-200 bg-white" data-testid={`${testPrefix}-box`}>
            <div className="flex items-center gap-2 border-b border-slate-100 px-2">
                <Search className="h-3.5 w-3.5 text-slate-400" />
                <input value={q} onChange={(e) => setQ(e.target.value)} placeholder="Cerca per nome o matricola…"
                    className="h-9 w-full bg-transparent text-sm outline-none" data-testid={`${testPrefix}-search`} />
                <span className="shrink-0 text-[11px] font-semibold text-[#376DB3]" data-testid={`${testPrefix}-count`}>{selected.length} selezionat{selected.length === 1 ? "o" : "i"}</span>
            </div>
            <div className={`${maxHeight} overflow-y-auto p-1`}>
                {list.length === 0 && <div className="px-2 py-3 text-xs text-slate-400">Nessun dipendente trovato</div>}
                {list.map((e) => {
                    const on = selected.includes(e.id);
                    return (
                        <button type="button" key={e.id} onClick={() => toggle(e.id)}
                            className={`flex w-full items-center gap-2 rounded px-2 py-1.5 text-left text-sm transition-colors ${on ? "bg-[#376DB3]/10" : "hover:bg-slate-50"}`}
                            data-testid={`${testPrefix}-item-${e.id}`} aria-pressed={on}>
                            <span className={`flex h-4 w-4 shrink-0 items-center justify-center rounded border ${on ? "border-[#376DB3] bg-[#376DB3] text-white" : "border-slate-300 bg-white"}`}>
                                {on && <Check className="h-3 w-3" />}
                            </span>
                            <span className="flex-1 truncate font-medium text-slate-700">{e.cognome} {e.nome}{e.matricola ? <span className="font-normal text-slate-400"> · {e.matricola}</span> : null}</span>
                            <span className="shrink-0 font-mono-numbers text-[11px] text-slate-500">
                                {fmtH(e.assigned_week_hours)}h{e.contratto_ore ? ` / ${fmtH(e.contratto_ore)}h` : ""}
                            </span>
                        </button>
                    );
                })}
            </div>
        </div>
    );
}
